import React from "react"

const SecondaryButton = (props) => {

    return (<div className="form-group btn-holder">
        <button id={props.id} type="button"
                onClick={() => {
                    props.onClick();
                }}
                className="button button--fullwidth button--shadow">{props.label}</button>
    </div>)
};


SecondaryButton.defaultProps = {
    id : "secondary-button-" + parseInt(Math.random() * 100),
    label : "SUBMIT & CONTINUE",
    analytics : {
        eventName : "Secondary Button Click",
        attributes : {}
    }
};

export default SecondaryButton
